<div class="modal__content paymodal">
    <h1>{{ $t('modals.payment.title') }}</h1>
    <h3>{{ $t('payment.package-choice') }}</h3>
    <div class="paymodal__packages">
        <div class="paymodal__packages-tile tile" v-for="(pack, key) in sortPackages" @click="selectPackage(pack.id)" :class="{ 'selected' : pack.id === selectedPack }">
            <div class="tile__discount" v-if="getBonusAmount(pack.price) > 0">
                {{ $filters.bonusPercentage(getBonusAmount(pack.price)) }}
            </div>
            <div class="tile__name" :class="{ 'selected' : pack.id === selectedPack, 'gold': pack.id === 4, 'silver': pack.id === 2, 'bronze': pack.id === 1  }">
                {{ $t('payment.packages.pack' + pack.id) }}
            </div>
            <div class="tile__price">{{ $filters.shortCurrency(pack.price) }} </div>
            <div class="tile__minutes">{{ Math.floor(pack.minutes) }} {{ $t('payment.minutes') }} </div>
            <div class="tile__toggle" :class="{ 'selected' : pack.id === selectedPack }" >
                <div class="tile__toggle-icon"  :class="{ 'selected' : pack.id === selectedPack }" ></div>
            </div>
        </div>
    </div>
    <h3>{{ $t('payment.methods-choice') }}</h3>
    <div class="paymodal__methods methods" v-if="getMethods">
        <div class="methods__item" v-for="paymentMethod in getMethods" :class="{ 'active': paymentMethod.abbr === selectedPayment }" v-on:click="selectPayment(paymentMethod.abbr)">    
            <div class="methods__img paymentIcons" :class="paymentMethod.abbr.replace(/\//g, '-')">
                <span></span>
            </div>
            <div class="methods__name" v-if="!userStore.mobile">
                <p v-html="$t('payment.methods.' + paymentMethod.info)"></p>
            </div>
            <div class="methods__issuers" :class="{'mobile': userStore.mobile}" v-if="paymentMethod.issuers && paymentMethod.abbr === selectedPayment">
                <div class="methods__issuers-form">
                    <div class="form__group">
                        <select @change="issuerChange($event)">
                            <option :value="'undefined'">{{ $t('payment.choicebank') }}</option>
                            <option v-for="is in paymentMethod.issuers" :value="is.id">{{ is.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="methods__toggle" :class="{ 'selected' : paymentMethod.abbr === selectedPayment }">
                <div class="methods__toggle-icon"  :class="{ 'selected' : paymentMethod.abbr === selectedPayment }" ></div>
            </div>
        </div>
    </div>
    <div class="action">
        <button class="btn btn-green" @click="doPayment()" :class="{ 'disabled': (!paymentDisabled || !canBuy) }">{{ $t('modals.new.next') }}</button>
    </div>
</div>
